import defaultsDeep from "lodash/defaultsDeep";
import { darken, lighten } from "polished";
import { aqua1000, blue700, cyan800, deepBlue700, deepBlue900, purple700, red1000, red900, steelGrey700, steelGrey800, teal900 } from "../colors";
import { alchemyDark } from "./alchemy-dark";
export const alchemyDarkContrast = defaultsDeep({
    structural: {},
    // Interactive
    interactiveNavigational: {
        base: lighten(0.015, steelGrey700),
        contrast: steelGrey800
    },
    interactiveConstructive: {
        base: darken(0.02, deepBlue700),
        contrast: deepBlue900
    },
    interactiveDestructive: {
        base: red900,
        contrast: red1000
    },
    // Visualization colors
    visualizationOne: {
        inverseContainer: darken(0.02, purple700)
    },
    visualizationThree: {
        inverseContainer: darken(0.085, aqua1000)
    },
    visualizationFour: {
        inverseContainer: darken(0.07, blue700)
    },
    visualizationFive: {
        inverseContainer: darken(0.07, cyan800)
    },
    visualizationSix: {
        inverseContainer: darken(0.087, teal900)
    }
}, alchemyDark);
